export const toggleSort = {
    type: 'toggle_sort'
};

export const toggleGroup = {
    type: 'toggle_group'
};